import { pageHead, unavailableHead, hasUnavailableMatch } from "@/lib/seoPolicy";
import { createFileRoute } from "@tanstack/react-router";
import Gallery from "@/pages/Gallery";

export const Route = createFileRoute("/_public/gallery")({
  head: ({ matches }) => hasUnavailableMatch(matches) ? unavailableHead() : pageHead("Project Gallery | Real Fence Installs by Modern Fence Install", "Browse real dog, deer, garden, and restoration fence installation photos from Modern Fence Install projects.", "/gallery", false),
  component: Gallery,
});
